module.exports = __webpack_public_path__ + "frontend/images/white/visual/white-bg.jpg?ec49cb62acdf8b2d1d075f2cdc0aeba2";